import { render } from "./hole_column.vue?vue&type=template&id=f2e304b6"
import script from "./hole_column.vue?vue&type=script&lang=js"
export * from "./hole_column.vue?vue&type=script&lang=js"

import "./hole_column.vue?vue&type=style&index=0&id=f2e304b6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__